module.exports = __webpack_public_path__ + "static/media/hab7-1.7017a4d7.jpg";